'use strict';

/**
 *
 * @name:
 *
 */

import angularticsGtmNownessConfig from './angulartics-gtm-nowness.config';

const AnalyticsModule = angular
  .module('angulartics.google.tagmanagerNowness', ['angulartics'])
  .config(angularticsGtmNownessConfig);

export default AnalyticsModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-analytics/angulartics-gtm-nowness.module.js